import { render, staticRenderFns } from "./ApprovalCategory.vue?vue&type=template&id=fba3f54c&scoped=true"
import script from "./ApprovalCategory.vue?vue&type=script&lang=js"
export * from "./ApprovalCategory.vue?vue&type=script&lang=js"
import style0 from "./ApprovalCategory.vue?vue&type=style&index=0&id=fba3f54c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba3f54c",
  null
  
)

export default component.exports